import React                            from 'react';
import ReactDOM                         from 'react-dom/client';
import App                              from './App';
import reportWebVitals                  from './reportWebVitals';
import { InitConfig, 
         RunContextApp, 
         RunState,
         RUN_MODE
       }                                from "./framework/RCApp";
import { LOG_LEVEL }                    from "./framework/RCLogger";
import { LicenseInfo }                  from '@mui/x-license';

// Import Inter font
import '@fontsource/inter/300.css'; // Light
import '@fontsource/inter/400.css'; // Regular
import '@fontsource/inter/500.css'; // Medium
import '@fontsource/inter/600.css'; // Semi-bold
import '@fontsource/inter/700.css'; // Bold

import './index.css';
import codiconTtfUrl from './assets/fonts/codicon.ttf';

// Configure Monaco Editor to use local npm package instead of CDN
import { loader } from '@monaco-editor/react';

// ResizeObserver fires this benign browser notification when it cannot deliver
// all observations within a single animation frame. It is not an application
// error — the browser retries in the next frame automatically. CRA's dev overlay
// registers a window.onerror handler that treats every error event as fatal, so
// we intercept and swallow this specific message before it reaches that handler.
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});

// Configure Monaco to use the npm package
loader.config({
  paths: { 
    vs: process.env.NODE_ENV === 'development' 
      ? '/node_modules/monaco-editor/min/vs'
      : `${process.env.PUBLIC_URL || ''}/static/monaco-editor/min/vs`
  } 
});

// Load Monaco codicon font early so Find/Replace widget icons render (not squares).
// Use family name "codicon-fixed" so Monaco's broken @font-face doesn't win.
if (typeof document !== 'undefined' && document.fonts && typeof document.fonts.check === 'function') {
  const font = new FontFace('codicon-fixed', `url(${codiconTtfUrl}) format("truetype")`, { display: 'block' });
  font.load().then((loaded) => { document.fonts.add(loaded); }).catch(() => {});
}

const runMode = process.env.REACT_APP_ENV as string;
const logLevel = process.env.REACT_APP_ENV === RUN_MODE.PROD ? LOG_LEVEL.NONE : LOG_LEVEL.DEBUG

const ic  = new InitConfig(runMode, logLevel, true)
const rs  = new RunState()
const rc  = new RunContextApp(ic, rs)
rc.init()

LicenseInfo.setLicenseKey("9e18a1f9970480e54e31eb4e487c2f36Tz0xMzAyMjUsRT0xODEzMTkwMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=");

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App rc={rc}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
